import { NgModule, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { authGuard, authInterceptor, AUTH_INTERCEPTOR_CONFIG } from '@org/ui-common/auth';
import { APICallerService, GlobalErrorHandlerService, GOOGLE_MAPS_CONFIG, RADAR_SERVICE_CONFIG, S3ConfigService, S3_CONFIG_SERVICE_CONFIG } from '@org/ui-common/services';
import { SpinnerComponent } from '@org/ui-common/components';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieModule } from 'ngx-cookie';
import { RouterModule, CanActivateFn } from '@angular/router';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { App } from './app';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs';

@NgModule({ 
    declarations: [
        App
    ],
    bootstrap: [App], 
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        RouterModule.forRoot(appRoutes),
        AppRoutingModule,
        NgbModule,
        CookieModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        SpinnerComponent
    ], 
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandlerService
        },
        {
            provide: AUTH_INTERCEPTOR_CONFIG,
            useValue: {
                appName: 'web-clmpportal',
                authUsername: environment.authUsername,
                authPassword: environment.authPassword,
                loginUrlPattern: 'way-auth/auth/login',
                insurancePathPatterns: ['/insurance-steps', '/auto-insurance', '/ai', '/insurance-pay'],
                errorLogUrl: environment.wayadmin + 'error/public/log'
            }
        },
        {
            provide: GOOGLE_MAPS_CONFIG,
            useValue: {
                apiKey: environment.googleMapsApiKey,
                libraries: ['places', 'geocoding']
            }
        },
        {
            provide: RADAR_SERVICE_CONFIG,
            useValue: {
                publishableKey: environment.radarPublishableKey,
                countryCode: environment.radarCountryCode,
                mapStyle: environment.radarMapStyle,
                s3ConfigUrl: environment.s3ConfigUrl
            }
        },
        {
            provide: S3_CONFIG_SERVICE_CONFIG,
            useValue: { 
                s3ConfigUrl: environment.s3ConfigUrl,
                appName: 'web-clmpportal'
            }
        },
        { provide: authGuard, useValue: authGuard }, NgbActiveModal,
        APICallerService,
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAppInitializer(() => {
            const s3ConfigService = inject(S3ConfigService);
            return firstValueFrom(s3ConfigService.loadConfig());
        })
    ] })

export class AppModule {
}

function provideAuthGuard(authGuard: CanActivateFn): import("@angular/core").Provider | import("@angular/core").EnvironmentProviders {
    return { provide: authGuard, useValue: authGuard };
}

